module.exports = __webpack_public_path__ + "img/red-circle-table-2.18e481a0.png";